(() => {
  'use strict';
  const dialog=document.querySelector('[data-hsx-product-panel]');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const body=dialog.querySelector('[data-panel-content]'),title=dialog.querySelector('#HsxPanelTitle'),back=dialog.querySelector('[data-panel-back]');
  const scroll=dialog.querySelector('.hsxf-panel__scroll'),cache=new Map(),history=[];
  let origin=null,controller=null,current=null,generation=0;
  const text=k=>window.HSXOffers?.text(k)||k;
  const routes=new Map([['/pages/shipping-policy','shipping'],['/pages/refund-policy','returns'],['/pages/privacy-policy','privacy'],['/pages/terms-of-use','terms'],['/pages/subscription-terms','subscription'],['/pages/assessment','assessment'],['/pages/rl100','rl100']]);
  function sanitize(main) {
    const content=document.createElement('div');
    const reading=main.querySelector('article[data-reading-root],article.hsx-study');
    content.append(...(reading||main).childNodes);
    content.querySelectorAll('script,style,iframe,form,object,embed,base,link,meta,noscript,dialog,button,input,select,textarea,[data-hsxp-buy],[data-hsx-offer],.hsxv-jump,.hsx-breadcrumbs,.hsxp-reading-progress,.hsx-reading-aside,.hsxj-article-actions,.hsx-article-cover,.hsxj-support-strip').forEach(n=>n.remove());
    content.querySelectorAll('*').forEach(node=>{
      for(const a of [...node.attributes])if(/^on/i.test(a.name)||a.name==='srcdoc'||a.name==='autofocus'||a.name==='style')node.removeAttribute(a.name);
      if(node.matches('a[href]')){
        try{
          const u=new URL(node.getAttribute('href'),location.origin);
          if(!['http:','https:','mailto:','tel:'].includes(u.protocol))node.removeAttribute('href');
          else if(['http:','https:'].includes(u.protocol)&&u.origin!==location.origin){node.target='_blank';node.rel='noopener noreferrer';}
        }catch{node.removeAttribute('href');}
      }
    });
    return content;
  }
  function mount(fragment,request,ticket) {
    const heading=fragment.querySelector('h1,h2'),ids=new Map();
    fragment.querySelectorAll('[id]').forEach((node,index)=>{
      const old=node.id,next=node===heading?title.id:'hsxf-reader-'+ticket+'-'+index;
      if(!ids.has(old))ids.set(old,next);
      node.id=next;
    });
    const source=new URL(request.url||location.href,location.origin);
    fragment.querySelectorAll('*').forEach(node=>{
      for(const name of ['aria-labelledby','aria-describedby','aria-controls','aria-details','aria-owns','headers','for']){
        if(node.hasAttribute(name))node.setAttribute(name,node.getAttribute(name).split(/\s+/).map(id=>ids.get(id)||id).join(' '));
      }
      if(node.matches('a[href]')){
        const raw=node.getAttribute('href');let u;
        try{u=new URL(raw,source);}catch{return;}
        if(u.hash&&(raw.startsWith('#')||u.origin===source.origin&&u.pathname===source.pathname)){
          let id;try{id=decodeURIComponent(u.hash.slice(1));}catch{id=u.hash.slice(1);}
          if(ids.has(id))node.setAttribute('href','#'+ids.get(id));
        }
      }
    });
    title.textContent=heading?.textContent?.trim()||request.title||text('help_title');
    heading?.remove();body.replaceChildren(fragment);scroll.scrollTop=0;title.focus({preventScroll:true});
    if(Number.isFinite(request.scrollTop))scroll.scrollTop=request.scrollTop;
    else if(source.hash){let id;try{id=decodeURIComponent(source.hash.slice(1));}catch{id=source.hash.slice(1);}const target=document.getElementById(ids.get(id));if(target&&dialog.contains(target))target.scrollIntoView({block:'start',behavior:'instant'});}
  }
  async function open(request,trigger,push=true) {
    if(push&&current)history.push({...current,scrollTop:scroll.scrollTop});current=request;
    dialog.dataset.panelKind=request.kind==='local'?'local':'reader';
    dialog.dataset.panelTopic=request.key||'reader';
    if(!dialog.open){origin=trigger||document.activeElement;dialog.showModal();document.documentElement.setAttribute('data-hsxf-panel-open','');}
    back.hidden=history.length===0;controller?.abort();controller=new AbortController();
    const requestController=controller,ticket=++generation;
    body.setAttribute('aria-busy','true');body.replaceChildren();title.textContent=text('loading');
    try {
      let fragment;
      if(request.kind==='local'){
        const template=document.querySelector('[data-panel-template="'+request.key+'"]');if(!template)throw Error();fragment=template.content.cloneNode(true);
      }else{
        const url=new URL(request.url,location.origin);const saved=new URLSearchParams(location.search).get('preview_theme_id');if(saved)url.searchParams.set('preview_theme_id',saved);
        const cacheKey=url.pathname+url.search;url.hash='';
        if(cache.has(cacheKey))fragment=cache.get(cacheKey).cloneNode(true);
        else{
          const response=await fetch(url,{credentials:'same-origin',signal:requestController.signal});if(!response.ok)throw Error();
          const doc=new DOMParser().parseFromString(await response.text(),'text/html'),main=doc.querySelector('#MainContent');
          if(!main)throw Error();fragment=sanitize(main);cache.set(cacheKey,fragment.cloneNode(true));
        }
      }
      if(ticket!==generation||requestController.signal.aborted||!dialog.open)return;
      mount(fragment,request,ticket);
    }catch(error){
      if(error.name==='AbortError'||ticket!==generation||!dialog.open)return;
      title.textContent=text('help_title');const p=document.createElement('p');p.textContent=text('load_error');body.replaceChildren(p);
      const a=document.createElement('a');a.href='mailto:support@healthspanx.org';a.textContent='support@healthspanx.org';body.append(a);
    }finally{if(ticket===generation)body.removeAttribute('aria-busy');}
  }
  document.addEventListener('click',e=>{
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    const trigger=e.target.closest('[data-hsx-panel]');
    if(trigger){e.preventDefault();open({kind:'local',key:trigger.dataset.hsxPanel},trigger);return;}
    const a=e.target.closest('a[href]');if(!a||a.closest('.hsx-v2-header,.hsxm-menu-dialog,.hsxp-search-dialog,.hsx-v2-footer')||a.hasAttribute('download')||a.target==='_blank'||a.matches('[data-hsxd-image],[data-hsxw-open]'))return;
    const raw=a.getAttribute('href');if(!raw||/^(mailto|tel):/.test(raw))return;
    if(raw[0]==='#'){
      if(dialog.contains(a)){
        const target=document.getElementById(raw.slice(1));
        if(target&&dialog.contains(target)){e.preventDefault();target.scrollIntoView({block:'start',behavior:'instant'});}
      }
      return;
    }
    const u=new URL(a.href,location.href);
    if(u.origin!==location.origin||/^\/(cart|checkout|account|cdn|apps|checkouts)(\/|$)/.test(u.pathname)||u.pathname===location.pathname&&u.hash)return;
    if(!/^\/(pages|blogs|search|collections)(\/|$)/.test(u.pathname)&&u.pathname!=='/')return;
    e.preventDefault();const view=u.searchParams.get('view');
    const local=u.pathname==='/pages/about'&&view==='hsx-quality'?'coa':u.pathname==='/pages/about'&&view==='hsx-contact'?'contact':routes.get(u.pathname);
    open(local?{kind:'local',key:local}:{kind:'url',url:u.pathname+u.search+u.hash,title:a.textContent.trim()},a);
  });
  dialog.querySelector('[data-panel-close]').addEventListener('click',()=>dialog.close());
  back.addEventListener('click',()=>{const previous=history.pop();if(previous)open(previous,null,false);});
  dialog.addEventListener('close',()=>{generation++;controller?.abort();history.length=0;current=null;body.removeAttribute('aria-busy');document.documentElement.removeAttribute('data-hsxf-panel-open');if(origin?.isConnected)origin.focus({preventScroll:true});});
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
})();
